<template>
  <div class="route-play" :class="{ custom: speed.key === -1 }">
    <div class="flex ah">
      <div class="lineCheck">
        <el-checkbox label="显示路线" v-model="showLine" @change="onLineStateChange"></el-checkbox>
      </div>
      <div class="auto" style="display: flex; justify-content: center">
        <Icon
          name="icon-suspend"
          type="big"
          content="播放"
          @click="play(true)"
          v-if="playState === 0"
        ></Icon>
        <Icon
          name="icon-play1"
          type="big"
          content="暂停"
          @click="pause()"
          v-else
        ></Icon>
      </div>
      <div class="my-divider"></div>
      <div class="auto" :class="{ custom: speed.key === -1 }">
        <el-dropdown @command="(o) => (speed = o)" :disabled="speed.key === -1 && playState === 1">
          <span class="white-color">
            {{ speed.label }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <div class="popover-content">
              <el-dropdown-item
                :command="item"
                v-for="(item, i) in speeds"
                :key="i"
              >
                <span>{{ item.label }}</span>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <el-input
          v-if="speed.key === -1"
          v-model="speedStr"
          :disabled="playState === 1"
          @input="(val, old) => (speedStr = positiveNumber(val, speedStr))"
          class="speed"
        >
          <template #suffix> km/h </template>
        </el-input>
      </div>
      <div class="my-divider"></div>
      <el-dropdown class="auto" @command="(o) => (way = o)">
        <span class="white-color">
          {{ way.label }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="popover-content">
            <el-dropdown-item
              :command="item"
              v-for="(item, i) in ways"
              :key="i"
            >
              <span>{{ item.label }}</span>
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="my-divider"></div>
      <div class="auto" style="display: flex; justify-content: center">
        <Icon
          name="icon-tuichu1"
          type="big"
          content="退出"
          @click="exit"
        ></Icon>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  inject: ['cesiumViewer'],
  data () {
    const speeds = [
      {
        key: 1,
        label: '0.5x',
        value: 0.5
      },
      {
        key: 2,
        label: '1.0x',
        value: 1
      },
      {
        key: 3,
        label: '1.5x',
        value: 1.5
      },
      {
        key: 4,
        label: '2.0x',
        value: 2
      },
      {
        key: -1,
        label: '自定义',
        value: 1
      }
      // {
      //   label: '10.0x',
      //   value: 10
      // }
    ]
    const ways = [
      {
        label: '侧方视角',
        value: 0
      },
      {
        label: '第三视角',
        value: 1
      },
      {
        label: '第一视角',
        value: 2
      }
    ]
    return {
      // 记录历史速度字符串
      oldSpeedStr: '',
      // 修改了自定义速度字符串
      modifySpeedStr: false,
      isPause: false,
      /**
       * 播放状态，0代表未播放，1代表播放中
       */
      playState: 0,
      // 速度字符串
      speedStr: '',
      speed: speeds[1],
      speeds,
      way: ways[1],
      ways,
      wayMap: {
        0: 'side',
        1: 'track',
        2: 'first'
      },
      showLine: true
    }
  },
  watch: {
    way (val) {
      this.$cesiumPlus.flyPathManager.perspective = this.wayMap[val.value]
    },
    speed (val, old) {
      // 代表选择自定义速度
      if (val.key === -1) {
        if (this.isPause) {
          this.$cesiumPlus.flyPathManager.restore()
        }
        // 先停止前一个动画（清理对象）
        this.$cesiumPlus.flyPathManager.stop()
        this.playState = 0
        this.isPause = false
      } else if (old.key === -1) {
        if (this.isPause) {
          this.$cesiumPlus.flyPathManager.restore()
        }
        // 先停止前一个动画（清理对象）
        this.$cesiumPlus.flyPathManager.stop()
        this.playState = 0

        this.isPause = false
        this.modifySpeedStr = false
      }
      this.$cesiumPlus.flyPathManager.multiplier = val.value
    },
    speedStr (val) {
      this.modifySpeedStr = true
    }
  },
  methods: {
    /**
     * 转换正整数
     */
    positiveNumber (val) {
      if (/^([0-9]{1,3}(\.[0-9]{0,2})?)$/g.test(val)) {
        return val
      } else {
        const ma = `${val}`.match(/([0-9]{1,3}(\.[0-9]{0,2})?)/g)
        return ma ? ma[0] : ''
      }
    },
    play (state) {
      this.playState = state ? 1 : 0
      if (this.isPause) {
        // 如果处于暂停状态，且修改了自定义速度，重建漫游路径
        if (this.modifySpeedStr) {
          this.modifySpeedStr = false
          const r = Number(this.speedStr) / Number(this.oldSpeedStr)
          this.$cesiumPlus.flyPathManager.multiplier = r
        }

        // 暂停中恢复播放
        this.$cesiumPlus.flyPathManager.restore()
        this.isPause = false

        return
      }
      this.oldSpeedStr = this.speedStr
      // 先停止前一个动画（清理对象）
      this.$cesiumPlus.flyPathManager.stop()

      const { pathType, marks, pathPlanning } = this.info
      let polyline = []
      switch (pathType) {
        case 'DRIVING':
        case 'WALKING':
          polyline = _.chain(pathPlanning.paths)
            .take(1)
            .map((p) => p.steps)
            .flatten()
            .map((p) => {
              return p.polyline
                .split(';')
                .map((str) => str.split(',').map((n) => Number(n)))
            })
            .flatten()
            .value()
          break
        default:
          polyline = _.chain(marks)
            .map(({ position }) => [position.lng, position.lat, position.alt])
            .value()
          break
      }
      if (pathType === 'DRIVING') {
        this.Driving(polyline)
      } else if (pathType === 'WALKING') {
        this.Walking(polyline)
      } else {
        this.UAV(polyline)
      }
    },
    /**
     * 暂停动画
     */
    pause () {
      this.isPause = true
      this.playState = 0
      this.$cesiumPlus.flyPathManager.pause()
    },
    /**
     * 无人机漫游
     */
    UAV (polyline) {
      const { way, speed, speedStr } = this
      this.$cesiumPlus.flyPathManager.play({
        paths: polyline,
        flyWay: 'distance',
        speed: speed.key === -1 && speedStr ? Number(speedStr) : 40,
        multiplier: speed.value,
        perspective: this.wayMap[way.value],
        orientationFollow: false,
        // gltf: '/model/fly/dajiang/dajiang.gltf',
        gltf: '/model/fly/dajiang/dajiang2.glb', // 偏移之后的模型
        // gltf: '/model/fly/MQ-9-Predator.glb',
        // gltf: '/model/fly/gltf2/gltf2.gltf',
        // gltf: '/model/fly/MQ-9-Predator.glb',
        onStop: () => (this.playState = 0),
        merge: (czml) => {
          // czml[1].model.maximumScale = 20
          czml[1].model.minimumPixelSize = 48
          // czml[1].model.minimumPixelSize = 32
          // czml[1].model.scale = 0.05
          return czml
        }
      })
    },
    /**
     * 驾车漫游
     */
    Driving (polyline) {
      const { way, speed, speedStr } = this
      this.$cesiumPlus.flyPathManager.play({
        paths: polyline,
        flyWay: 'distance',
        speed: speed.key === -1 && speedStr ? Number(speedStr) : 60,
        multiplier: speed.value,
        clampToGround: 'CLAMP_TO_MODEL',
        perspective: this.wayMap[way.value],
        gltf: '/model/cars/car1.gltf',
        onStop: () => (this.playState = 0),
        merge: (czml) => {
          czml[1].model.minimumPixelSize = 78
          czml[1].model.scale = 1
          return czml
        }
      })
    },
    /**
     * 步行漫游
     */
    Walking (polyline) {
      const { way, speed, speedStr } = this
      this.$cesiumPlus.flyPathManager.play({
        paths: polyline,
        flyWay: 'distance',
        speed: speed.key === -1 && speedStr ? Number(speedStr) : 5,
        multiplier: speed.value,
        clampToGround: 'CLAMP_TO_MODEL',
        perspective: this.wayMap[way.value],
        gltf: '/model/walks/walk.gltf',
        onStop: () => (this.playState = 0),
        merge: (czml) => {
          czml[1].model.minimumPixelSize = 78
          czml[1].model.scale = 1
          return czml
        }
      })
    },
    exit () {
      this.$cesiumPlus.flyPathManager.stop()
      this.$emit('exit')
    },
    onLineStateChange () {
      this.$emit('showLine', this.showLine)
    }
  },
  mounted () {
    // todo
  },
  destroyed () {
    this.$cesiumPlus.flyPathManager.restore()
    this.$cesiumPlus.flyPathManager.stop()
  }
}
</script>
<style lang="scss">
.route-play {
  .speed.el-input.el-input--suffix {
    .el-input__inner {
      padding-right: 35px;
    }
  }
}
</style>
<style lang="scss" scoped>
.custom-icon {
  > svg {
    color: white !important;
  }
}
.route-play {
  --width: 450px;

  position: absolute;
  left: calc(50% - var(--width) / 2);
  bottom: 38px;
  // width: 329px;
  // height: 44px;
  // background: rgba(0, 0, 0, 0.7);
  // box-shadow: 1px 4px 6px 0px rgba(0, 0, 0, 0.3);
  // border-radius: 10px;

  width: var(--width);
  height: 44px;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid #53575b;
  box-shadow: 1px 4px 6px 0px rgba(0, 0, 0, 0.3);
  opacity: 0.8;
  border-radius: 10px;

  color: white;

  &.custom {
    --width: 529px;
  }
}
.white-color {
  color: white;
}
.flex {
  display: flex;
  align-items: center;
  >.lineCheck{
    margin-left: 12px;
  }
  > .auto {
    flex: 1;
    // flex-grow: 1;
    // flex-shrink: 0;
    // flex-basis: 0%;
  }
  > .auto.custom {
    flex: 2.5;
    // flex-grow: 1;
    // flex-shrink: 0;
    // flex-basis: 0%;
  }
}
.my-divider {
  width: 1px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.16);
}

.speed {
  margin-left: 12px;
  width: 100px;
}
</style>
